export const copyText = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
    } catch (error) {
        console.error('Неможливо скопіювати текст:', error);
    }
};